import { FC, lazy } from 'react';
import { useParams } from 'react-router-dom';
import { useAssignedOperators } from 'src/apis/monolith/use-assigned-operators';
import { useFutureShipperUser } from 'src/apis/monolith/use-future-shipper-user';
import { useShipper } from 'src/apis/monolith/use-shipper';
import { useShipperUser } from 'src/apis/monolith/use-shipper-user';
import { useShipperUserData } from 'src/apis/monolith/use-shipper-user-data';
import { useOrganisationService } from 'src/pages/settings/organisation/use-organisation-service';

const Page = lazy(() => import('./page'));

export const ShipperUserDetails: FC = () => {
  const { oldUserId } = useParams<{ oldUserId: string }>();
  const shipper = useShipper();
  const shipperUser = useShipperUser(oldUserId!);
  const futureShipperUser = useFutureShipperUser(oldUserId!);
  const shipperUserData = useShipperUserData(oldUserId!);
  const assignedOperators = useAssignedOperators(shipperUserData);
  const organisationService = useOrganisationService();

  return (
    <Page
      shipper={shipper}
      shipperUser={shipperUser}
      futureShipperUser={futureShipperUser}
      shipperUserData={shipperUserData}
      assignedOperators={assignedOperators}
      organisationService={organisationService}
    />
  );
};
